import React from "react";
import {
  User,
  Calendar,
  ClipboardList,
  Banknote,
} from "lucide-react";
import PendingCardBadges from "../shared/PendingCardBadges";

const PendingPaymentList = ({ data, onSelect }) => {
  if (!data || data.length === 0) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const monthShort = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${monthShort}-${year}`;
  };

  return (
    <div className="mb-5 md:mb-6">
      <h2 className="font-semibold text-sm md:text-base text-gray-700 mb-3 ml-1 md:ml-2">
        Phiếu thanh toán chờ duyệt ({data.length} phiếu)
      </h2>

      <div className="flex md:grid overflow-x-auto md:overflow-visible gap-3 md:gap-4 pb-1 md:pb-0 snap-x md:grid-cols-3 lg:grid-cols-4 no-scrollbar">
        {data.map((req) => {
          const needsMyApproval = Boolean(req.needs_my_approval);
          const isUrgent = Boolean(req.is_urgent);

          return (
            <button
              key={req.id}
              type="button"
              onClick={() => onSelect?.(req)}
              className={`snap-start shrink-0 w-[82%] sm:w-[46%] md:w-auto relative text-left bg-white border rounded-2xl shadow-sm hover:shadow-md active:scale-[0.99] transition-all p-4 overflow-hidden ${
                isUrgent
                  ? "border-orange-200 hover:border-orange-300 ring-1 ring-orange-100/80"
                  : needsMyApproval
                    ? "border-red-200 hover:border-red-300 ring-1 ring-red-100/80"
                    : "border-gray-100 hover:border-red-100"
              }`}
            >
              <PendingCardBadges
                isUrgent={isUrgent}
                needsMyApproval={needsMyApproval}
              />

              <div className="flex items-center text-sm md:text-base font-semibold text-red-700 mb-1 min-w-0">
                <User className="mr-2 text-gray-400 shrink-0" size={18} />
                <span className="truncate uppercase">
                  {req.employee_name?.toUpperCase()}
                </span>
              </div>

              <div className="flex items-center text-xs md:text-sm text-gray-600 mb-1">
                <Calendar className="mr-2 text-gray-400 shrink-0" size={16} />
                {formatDate(req.payment_date || req.created_at)}
                {req.current_level != null ? (
                  <span className="ml-2 text-[10px] font-black uppercase text-amber-700 bg-amber-50 border border-amber-100 px-1.5 py-0.5 rounded-md">
                    Cấp {req.current_level}
                  </span>
                ) : null}
              </div>

              <div className="flex items-start text-xs md:text-sm text-gray-600 mb-1">
                <ClipboardList className="mr-2 text-gray-400 mt-0.5 shrink-0" size={16} />
                <span className="line-clamp-2">{req.payment_reason}</span>
              </div>

              <div className="flex items-center text-sm font-bold text-gray-800 mt-2">
                <Banknote className="mr-2 text-red-500 shrink-0" size={16} />
                {req.payment_amount
                  ? `${Number(req.payment_amount).toLocaleString("vi-VN")} ₫`
                  : "0 ₫"}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PendingPaymentList;
